module.exports = __webpack_public_path__ + "static/img/search_empty.191ddf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/search_empty.png
// module id = DetN
// module chunks = 192